module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767331_06_ack#ack"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767331_07_int#int"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292767331_08_ch1#ch1"
    }
  }, [_vm._v("1. From Harlem, Jamaica, and the Segregated Navy to New York City’s Interracial Left-Wing Culture, 1927–1948")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_09_ch2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Black Left, White Stage, Cold War: "), _c('em', [_vm._v("Moving into the Spotlight, 1949–1954")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_10_ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Multimedia Stardom and the Struggle for Racial Equality, 1955–1960")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_11_ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Storming the Gates: "), _c('em', [_vm._v("Producing Film and Television, 1957–1970")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_12_aft#aft",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AFTERWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_13_abb#abb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABBREVIATIONS FOR NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_14_not#not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292767331_15_ind#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3153f101","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292767331_05_toc.vue
// module id = 72
// module chunks = 0